import Class from './c-date-picker';
import './c-date-picker@';

export default Class;